// KAVE AI WORKSHOP - PREMIUM PRODUCTION DATA

export const workshopData = {
  // Workshop Batches (Sprint removed - only Batch 1 & 2)
  batches: [
    {
      id: 1,
      name: "Batch 1",
      dates: "27th & 28th March",
      available: true
    },
    {
      id: 2,
      name: "Batch 2",
      dates: "3rd & 4th April",
      available: true
    }
  ],

  // Hero Section
  hero: {
    headline: "Install AI Systems In Your Business To Scale Revenue",
    subheadline: "Stop experimenting with random AI tools.",
    description: "In this 2-day live implementation workshop, you'll learn how to deploy practical AI systems across marketing, sales, and operations — so your business runs faster, leaner, and more profitably.",
    videoUrl: "https://youtu.be/K9sXP6lSi5g",
    videoHeading: "Watch How This Works",
    ctaText: "Join Workshop – ₹499"
  },

  // What You'll Get Section (NO question mark)
  whatYouLearn: {
    heading: "What You'll Get",
    intro: "By the end of these 2 days, you will clearly know how to:",
    items: [
      {
        title: "AI Opportunities",
        description: "Identify exactly where AI can drive real ROI in your business.",
        icon: "Target"
      },
      {
        title: "Workflow Automation",
        description: "Build systems that reduce manual workload and improve efficiency.",
        icon: "Cog"
      },
      {
        title: "AI Creatives",
        description: "Create high-converting ads and founder-led content using AI.",
        icon: "Sparkles"
      },
      {
        title: "Sales Automation",
        description: "Streamline lead handling and support without hurting experience.",
        icon: "TrendingUp"
      },
      {
        title: "Scalable Systems",
        description: "Structure your business processes for faster, profitable growth.",
        icon: "Zap"
      }
    ],
    footer: "Not AI gyaan. Pure business implementation."
  },

  // Who This Is For (NO question mark)
  whoThisIsFor: {
    heading: "Who This Workshop Is For",
    personas: [
      {
        title: "D2C Founders",
        description: "Running consumer brands and looking to scale efficiently."
      },
      {
        title: "B2C Operators",
        description: "Service or product businesses facing growth bottlenecks."
      },
      {
        title: "Agency Owners",
        description: "Teams wanting better delivery speed and margins."
      },
      {
        title: "Scaling Businesses",
        description: "Doing roughly ₹50L–₹5Cr and preparing for next phase."
      },
      {
        title: "Serious Operators",
        description: "Founders ready to implement systems — not just learn tools."
      }
    ]
  },

  // Who This Is NOT For (NO question mark)
  whoThisIsNotFor: {
    heading: "Who This Workshop Is NOT For",
    items: [
      {
        title: "Students",
        description: "Exploring AI casually or academically."
      },
      {
        title: "Job Seekers",
        description: "Looking to use AI for employment or freelancing."
      },
      {
        title: "Beginners",
        description: "No active business or revenue yet."
      },
      {
        title: "Tool Collectors",
        description: "Wanting AI hacks without execution."
      },
      {
        title: "Passive Learners",
        description: "Not ready to implement inside their business."
      }
    ]
  },

  // Testimonials Section (NO question mark, with star ratings)
  testimonials: {
    heading: "What Founders Say",
    reviews: [
      {
        name: "Rajesh Kumar",
        title: "D2C Founder",
        review: "Sahil's workshop helped us automate 60% of our customer support. Game changer for our team.",
        rating: 5
      },
      {
        name: "Priya Sharma",
        title: "Agency Owner",
        review: "Finally understood how to use AI practically. Not theory - actual systems we implemented the next week.",
        rating: 5
      },
      {
        name: "Amit Patel",
        title: "B2C Operator",
        review: "Worth every rupee. The frameworks alone saved us weeks of trial and error.",
        rating: 5
      },
      {
        name: "Sneha Reddy",
        title: "Scaling Founder",
        review: "Clear, actionable, no fluff. Exactly what busy founders need.",
        rating: 5
      },
      {
        name: "Vikram Singh",
        title: "Consultant",
        review: "Best investment for understanding AI in business operations. Highly recommend.",
        rating: 5
      },
      {
        name: "Neha Gupta",
        title: "D2C Brand",
        review: "Implemented 3 systems within a week. Our operations are now 10x more efficient.",
        rating: 5
      },
      {
        name: "Arjun Mehta",
        title: "Service Business",
        review: "Sahil breaks down AI implementation like no one else. Practical and results-driven.",
        rating: 5
      }
    ]
  },

  // Instructor Section (Cinematic Authority Version)
  instructor: {
    name: "Sahil Gujral",
    title: "Founder & CEO, KAVE AI",
    videoUrl: "https://customer-assets.emergentagent.com/job_43f73832-e5ca-491d-9bd2-445099168f89/artifacts/ncmxggdg_Final%202.mp4",
    imageUrl: "https://customer-assets.emergentagent.com/job_43f73832-e5ca-491d-9bd2-445099168f89/artifacts/0ap7ienk_DSC00635.png",
    description: [
      "Sahil Gujral is a systems-focused growth operator and founder of WEHIT and KAVE, built on one core belief: businesses don't scale with more tools — they scale with better systems.",
      "He has worked with D2C brands, agencies, and service businesses to identify growth bottlenecks and implement practical AI and automation workflows that improve efficiency, reduce costs, and drive revenue.",
      "Through KAVE, his mission is simple — help revenue-stage businesses become AI-ready with structured, implementation-first systems that actually move business numbers."
    ],
    highlight: "Learn directly from someone implementing AI systems across real businesses every week.",
    stats: [
      { number: "100+", label: "Businesses Helped" },
      { number: "15K+", label: "YouTube Audience" },
      { number: "50+", label: "AI Systems Built" }
    ],
    social: {
      youtube: "https://www.youtube.com/@sahilgujralofficial",
      instagram: "https://www.instagram.com/_.sahilgujral/"
    }
  },

  // Media Strip (with actual logo URLs and links)
  mediaStrip: {
    heading: "As Featured In",
    logos: [
      {
        name: "DailyHunt",
        url: "https://customer-assets.emergentagent.com/job_kave-business-ai/artifacts/5wku0beo_dailyhunt.png",
        link: "http://m.dailyhunt.in/news/india/english/r+news+india-epaper-dhfacc36dfce9c4bb68db0e89d033c921b/from+18000+freelance+income+to+a+3+crore+annual+recurring+revenue+arr+business+how+sahil+gujral+built+wehit+from+the+ground+up-newsid-dhfacc36dfce9c4bb68db0e89d033c921b_1b16c8e0ea1b11f09eafbbefdaeb18a0?sm=Y"
      },
      {
        name: "Business Deccan",
        url: "https://customer-assets.emergentagent.com/job_kave-business-ai/artifacts/a6sexbnu_Untitled-1.png",
        link: "https://deccanbusiness.com/from-rs-18000-freelance-income-to-a-rs-3-crore-annual-recurring-revenue-arr-business-how-entrepreneur-sahil-gujral-built-wehit-from-the-ground-up/"
      },
      {
        name: "Republic News India",
        url: "https://customer-assets.emergentagent.com/job_kave-business-ai/artifacts/4r142zyx_republic%202.png",
        link: "https://business.republicnewsindia.com/from-rs-18000-freelance-income-to-a-rs-3-crore-annual-recurring-revenue-arr-business-how-entrepreneur-sahil-gujral-built-wehit-from-the-ground-up/"
      }
    ]
  },

  // Bonuses Section
  bonuses: {
    heading: "Bonuses Worth ₹7,999 Included",
    items: [
      "AI Prompt Library for Founders",
      "Ad Creative Prompt Pack",
      "Workflow Automation Templates",
      "Implementation Planning Toolkit",
      "Lifetime Community Access"
    ]
  },

  // Money Back Guarantee
  moneyBackGuarantee: {
    heading: "7-Day Money Back Guarantee",
    description: "Attend the workshop. If you feel it's not useful for your business, let us know within 7 days and we'll refund you. No drama."
  },

  // Pricing Section
  pricing: {
    price: 299,
    originalPrice: 1999,
    currency: "₹",
    valueStack: [
      "3-hour live workshop",
      "AI systems installation",
      "Templates & frameworks",
      "Lifetime community",
      "Recording access",
      "1-week support"
    ],
    urgency: "Limited seats",
    ctaText: "Secure Your Spot – ₹499"
  },

  // FAQ Section
  faqs: [
    {
      question: "Is this workshop beginner-friendly?",
      answer: "No. This workshop is designed for founders already running a business. If you don't have real operations, team, or revenue yet — this will feel advanced."
    },
    {
      question: "Will you teach AI tools step-by-step?",
      answer: "We will cover tools where necessary — but the focus is on business systems and implementation thinking, not random tool tutorials."
    },
    {
      question: "What kind of businesses is this most relevant for?",
      answer: "D2C brands, B2C businesses, agencies, and service companies doing roughly ₹50L–₹5Cr annually and facing scale or efficiency bottlenecks."
    },
    {
      question: "Will we build anything practical inside the workshop?",
      answer: "Yes. You will leave with clear AI implementation blueprints you can apply directly inside your marketing, sales, and operations workflows."
    },
    {
      question: "How is this different from free AI content on YouTube?",
      answer: "Most free content talks about tools. This workshop focuses on where AI actually impacts revenue, margins, and operational speed inside real businesses."
    },
    {
      question: "Is this a done-for-you service?",
      answer: "No. This is an implementation workshop. You will learn how to structure and deploy AI systems inside your business — not outsource them during the session."
    },
    {
      question: "What happens after the workshop if I want deeper implementation help?",
      answer: "Serious founders who want hands-on execution support will get the opportunity to apply for our advanced implementation program (limited and selective)."
    },
    {
      question: "What if I am not satisfied after joining?",
      answer: "We recommend joining only if you are a serious operator. Full participation and implementation mindset are expected to get maximum value from the workshop."
    }
  ],

  // Final CTA Section
  finalCta: {
    headline: "Ready to Install AI Systems in Your Business",
    subheadline: "Join the workshop and start executing today.",
    ctaText: "Join Now – ₹499"
  },

  // Thank You Page
  thankYou: {
    headline: "You're In!",
    message: "Your spot is confirmed. Join the WhatsApp community below for all workshop updates.",
    nextSteps: [
      "Check your email for workshop access details",
      "Join our WhatsApp community below",
      "Add workshop dates to your calendar",
      "Download your bonus materials"
    ],
    whatsappLink: "https://chat.whatsapp.com/Bxw7N3IbgLK7e7Qi2D2H4y",
    whatsappCtaText: "Join WhatsApp Community",
    supportContact: "support@kave.ai",
    bonusInfo: "Bonuses worth ₹7,999 are available in your member dashboard"
  },

  // Payment Integration
  payment: {
    cashfreeLink: "https://payments.cashfree.com/forms/kaveaiworkshop"
  },

  // Sticky Bar Configuration (appears at 25% scroll)
  stickyBar: {
    seatsLeft: 12,
    enabled: true,
    scrollTrigger: 25 // percentage
  },

  // Global Timer Configuration (15 minutes, synced across all instances)
  timer: {
    minutes: 15
  }
};
